import React, { Component } from 'react'
import '../main.css'
import Modal from 'react-modal';
import { deleteCall } from '../../../helpers/api/api'
import { login } from '../../../store/actions/auth'

class ListData extends Component {

    constructor(props) {
        super(props)
        this.state = {
            silModal: false,
            selectedId: "",
            errorMessage: false,
            mainUrl: "http://localhost:5000/"
        }
        this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.deleteItem = this.deleteItem.bind(this)
    }

    async handleOpenModal(d) {
        await this.setState({ selectedId: d._id, silModal: true, errorMessage: false });
    }

    async handleCloseModal() {
        await this.setState({ silModal: false, errorMessage: false });
    }

    deleteItem() {

        deleteCall(this.props.endPoint, { _id: this.state.selectedId })
            .then(res => {console.log(res); window.location.reload(false)})
            .catch(err => {
                if (err.message === "Request failed with status code 401") {
                    login("")
                }
                this.setState({ errorMessage: true })
            })
    }

    render() {
        return (
            <React.Fragment>
                <Modal
                    isOpen={this.state.silModal}
                    onRequestClose={this.handleCloseModal}
                    style={customStyles}
                >
                    <div>
                        Veriyi silmek istediğinize emin misiniz?<br></br>
                        {this.state.errorMessage && <p style={{ color: "red" }}>Silinemedi</p>}
                        <button onClick={this.deleteItem} className="blue-button">Sil</button>
                        <button onClick={() => this.handleCloseModal()} className="blue-button">Vazgeç</button>
                    </div>
                </Modal>
                {this.props.data.map((d, index) => {
                    return (
                        <div className={(index % 2 !== 0 ? "first-background-color" : "second-background-color") + " lists-main-container"}>
                            {this.props.dataInfo.map(dI => {
                                return (
                                    dI.objectPropName === "image" || dI.objectPropName === "smallImage" || dI.objectPropName === "bannerImage"
                                        ?
                                        <div className={dI.className}><img style={{ maxWidth: "100%" }} height="auto" src={this.state.mainUrl + d[dI.objectPropName]} alt="dataimage"></img></div>
                                        :
                                        dI.objectPropName === "dosya"
                                            ?
                                            <div className={dI.className}>{d[dI.objectPropName] ? <a className="blue-href" href={this.state.mainUrl + d[dI.objectPropName]}>link</a> : ""}</div>
                                            :
                                            dI.objectPropName === "link"
                                                ?
                                                <div className={dI.className}>{d[dI.objectPropName] ? <a className="blue-href" href={d[dI.objectPropName]}>link</a> : ""}</div>
                                                :
                                                <div className={dI.className}><p style={{ color: d.color ? d.color : "initial", wordWrap: "break-word" }}>{d[dI.objectPropName]}</p></div>
                                )
                            })}
                            <div style={{marginBottom: "10px", marginTop:"10px"}} className={this.props.buttons.className + " list-button-container"}>
                                {this.props.buttons.buttonData.map(bn => {
                                    return (
                                        bn.name === "Sil"
                                            ?
                                            <button onClick={async () => await this.handleOpenModal(d)} className="blue-button" >{bn.name}</button>
                                            :
                                            <button onClick={async () => await bn.func(d)} className="blue-button">{bn.name}</button>
                                    )
                                })}
                            </div>
                        </div>
                    )
                })}
            </React.Fragment>
        )
    }
}

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};

export default ListData
